import LeadLiaisonPhaserGame from "./LeadLiaisonPhaserGame";
import Phaser from 'phaser'

import UserComponent from "./components/UserComponent"
import autoResizeText from "./components/autoResizeText"
import autoResize from "./components/autoResize"
import PhysicsObject from "./components/physicsObject"
import WebFontFile from './WebFontFile'

window.UserComponent = UserComponent;



window.UserComponent = UserComponent;
window.autoResizeText = autoResizeText;
window.autoResize = autoResize;
window.PhysicsObject = PhysicsObject;


export default class Boot extends Phaser.Scene {
  
     preload() {
      if (LeadLiaisonGame.settings.gameData.scaleMode !== 'fit') {
      this.game.canvas.style.width = `${window.innerWidth}px`;
      this.game.canvas.style.height = `${window.innerHeight}px`;
      this.scale.setGameSize(window.innerWidth*window.devicePixelRatio, window.innerHeight*window.devicePixelRatio);
      this.scale.parent = null;
      }

      this.load.setCORS("anonymous");
      this.loadFiles();
         // ll_activation_rendering_manager.loading_cover_image_manager.show_img(ll_activation_rendering_manager.loadingImage);
      this.drawProgressBar(400, 50);

      // add/load google fonts family

      this.load.addFile(new WebFontFile(this.load, ll_activation_rendering_manager.get_google_fonts()));
     
    }
  
     loadFiles() {
      this.load.pack("pack", {section1:{files:LeadLiaisonGame.assets}});
      if (ll_activation_rendering_manager.COMPLETE_LOAD_ACTIVATION === ll_activation_rendering_manager.get_load_complete_action()) {
          this.load.script("Main", LeadLiaisonGame.settings.gameData.gamePath+"Main.js");
      }

    }
  
    drawProgressBar(barWidth, barHeight) {
        // ll_activation_rendering_manager.loading_cover_image_manager.show_img(ll_activation_rendering_manager.loadingImage);
      let container = this.add.container(
        this.cameras.main.centerX - barWidth / 2,
        this.cameras.main.centerY - barHeight / 2
      );
  
      this.barWidth = barWidth;
      this.barHeight = barHeight;
  
      this.graphics = this.add.graphics();
      this.newGraphics = this.add.graphics();
  
      var progressBar = new Phaser.Geom.Rectangle(0, 0, barWidth, barHeight);
      this.graphics.fillStyle(LeadLiaisonGame.settings.borderLoadingBarColor ?? 0xff0000, 1);

      this.graphics.fillRectShape(progressBar);
  
      container.add(this.graphics);
      container.add(this.newGraphics);
  
      this.load.on("progress", this.updateBar, this);
  
      this.updateBar(0);
    }
  
    updateBar(percentage) {
      this.newGraphics.clear();
      document.getElementById("background").style.backgroundColor=LeadLiaisonGame.settings.backgroundColor||"#242424";
      this.newGraphics.fillStyle(LeadLiaisonGame.settings.loadingBarColor ?? 0x3587e2 , 1);
      this.newGraphics.fillRectShape(
        new Phaser.Geom.Rectangle(
          5,
          5,
          percentage * (this.barWidth - 10),
          this.barHeight - 10
        )
      );
        if(percentage == 1)
        {
            ll_activation_rendering_manager.loading_cover_image_manager.hide_img();
        }
    }
  
    async create() {
      let settings = {};
      if(typeof ll_activation_rendering_manager != 'undefined'){
         settings = ll_activation_rendering_manager.activation_settings;
      } else {
         settings = LeadLiaisonGame.settings;
      }

      settings.gameData.gameId = settings.gameData.gameId || gameId;
      settings.gameData.gamePath = settings.gameData.gamePath || gamePath;
      settings.gameData.isWinner = typeof settings.isWinner != 'undefined' ? settings.isWinner : 0;
      settings.gameData.settings = settings;

      settings.backgroundColor = settings.backgroundColor || "#242424";
      settings.gameData.gameScale =
          settings.gameData.gameScale || window.devicePixelRatio;
      settings.gameData = {
        ...settings.gameData,
        // ...urlParams
      };

      this.scene.add("LeadLiaisonPhaserGame", LeadLiaisonPhaserGame);
      this.scene.start("LeadLiaisonPhaserGame", { settings: settings });

      LeadLiaisonGame.init();
    }
  }